<template>

    <form-section @submitted="updatePassword">

        <template #title>

            <font-awesome-icon class="text-blue mr-6"
                style="width: 27px;height: 27px;"
                :icon="['fas', 'key']">
            </font-awesome-icon>

            <div class="text-3xl font-nexa text-blue mt-2">
                {{ __('Password') }}
            </div>

        </template>


        <template #form>

            <div class="col-span-full sm:col-span-2">

                <Label class="text-black text-lg font-nexa mb-2"
                    for="current_password" :value="__('Current password')" />

                <Input class="w-full"
                    id="current_password" type="password" v-model="form.current_password"
                    ref="current_password" autocomplete="current-password" />

                <InputError class="mt-2"
                    :message="form.errors.current_password" />

            </div>


            <div class="col-span-full sm:col-span-2 sm:row-start-2">

                <Label class="text-black text-lg font-nexa mb-2"
                    for="password" :value=" __('New password') "/>

                <Input class="w-full"
                    id="password" type="password" v-model="form.password"
                    ref="password" autocomplete="new-password" />

                <InputError class="mt-2"
                    :message="form.errors.password" />

            </div>


            <div class="col-span-full sm:col-span-2 sm:row-start-2">

                <Label class="text-black text-lg font-nexa mb-2"
                    for="password_confirmation"
                    :value="__('Confirm password')" />

                <Input class="w-full"
                    id="password_confirmation" type="password"
                    v-model="form.password_confirmation" autocomplete="new-password" />

                <InputError class="mt-2"
                    :message="form.errors.password_confirmation"  />

            </div>

        </template>


        <template #actions>

            <Button class=""
                :class="{ 'opacity-25': form.processing }"
                :disabled="form.processing">
                {{ __('Save new password') }}
            </Button>

            <ActionMessage class="ml-4"
                :on="form.recentlySuccessful"
                type="success">
                {{ __('Saved') }}
            </ActionMessage>

        </template>

    </form-section>

</template>

<script>
import {defineComponent} from 'vue'
import ActionMessage from '@/Components/ActionMessage.vue'
import Button from '@/Components/Button.vue'
import FormSection from '@/Components/FormSection.vue'
import Input from '@/Components/Input.vue'
import InputError from '@/Components/InputError.vue'
import Label from '@/Components/Label.vue'

export default defineComponent({

    components: {
        ActionMessage,
        Button,
        FormSection,
        Input,
        InputError,
        Label,
    },

    data() {
        return {
            form: this.$inertia.form({
                current_password: '',
                password: '',
                password_confirmation: '',
            }),
        }
    },


    methods: {

        updatePassword() {

            this.form.put(route('user-password.update'), {
                errorBag: 'updatePassword',
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
                onError: () => {
                    if (this.form.errors.password) {
                        this.form.reset('password', 'password_confirmation')
                        this.$refs.password.focus()
                    }

                    if (this.form.errors.current_password) {
                        this.form.reset('current_password')
                        this.$refs.current_password.focus()
                    }
                }
            })

        },

    },
})
</script>
